import React from 'react';
import { isNull } from 'lodash';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import Select from '../../../../../components/input/Select';
import Anchor from '../../../../../components/link/Anchor';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenOrderItemDetail from '../../../../../components/link/OpenOrderItemDetail';
import OpenUserDetail from '../../../../../components/link/OpenUserDetail';
import {
  addAllItemToSelectList,
  asyncSimpleModal,
  setClearDash,
  setColumnWidth,
  setDash,
  setPhoneFormat,
  setNumberWithComma,
} from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import SendMessageService from '../../../../../containers/app/common/SendMessageService';
import { setOrderMessage } from '../../../../../lib/utils/orderutils';
import { AMONDZ_MEMBER_TYPE, DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import {
  ORDER_ACCEPT_MANAGER_TEXT,
  ORDER_CANCEL_STATUS_TEXT,
  ORDER_CANCEL_TYPE_TEXT,
  ORDER_GIFT_STATUS_SELECT_LIST,
  ORDER_GIFT_STATUS_TEXT,
  ORDER_TYPE_SELECT_LIST,
  ORDER_TYPE_TEXT,
  ORDER_PROCESS_MANAGER_TEXT,
  PAYMENT_METHOD_TYPE_SELECT_LIST,
  PAY_METHOD_TYPE_TEXT,
} from '../../../../../constants/service/app/orderConstants';

/**
 *  주문 취소 리스트 컬럼
 */
const columns = (data) => {
  const { list, filterOption, onFilter, mainProductCategorySelectList } = data;
  return [
    {
      accessor: 'orderType',
      Header: '주문 타입',
      filterable: true,
      width: setColumnWidth(list, 'orderType'),
      Cell: (row) => setDash(ORDER_TYPE_TEXT[row.value]),
      Filter: () => (
        <Select
          isTable
          list={addAllItemToSelectList(ORDER_TYPE_SELECT_LIST)}
          value={filterOption.orderType}
          onChange={(orderType) => onFilter({ orderType })}
        />
      ),
    },
    {
      accessor: 'giftStatus',
      Header: '선물 상태',
      filterable: true,
      width: 150,
      Cell: (row) => setDash(ORDER_GIFT_STATUS_TEXT[row.value]),
      Filter: () => (
        <Select
          isTable
          list={addAllItemToSelectList(ORDER_GIFT_STATUS_SELECT_LIST)}
          value={filterOption.giftStatus}
          onChange={(giftStatus) => onFilter({ giftStatus })}
        />
      ),
    },
    {
      Header: '취소 정보',
      fixed: 'left',
      columns: [
        {
          accessor: 'orderId',
          Header: '주문번호',
          filterable: true,
          width: 150,
          Filter: () => (
            <TableFilterInput option={filterOption.orderId} onFilter={(orderId) => onFilter({ orderId })} />
          ),
        },
        {
          accessor: 'orderItemId',
          Header: '상품 주문번호',
          filterable: true,
          width: 150,
          Cell: (row) => <OpenOrderItemDetail text={row.value} orderItemId={row.value} />,
          Filter: () => (
            <TableFilterInput option={filterOption.orderItemId} onFilter={(orderItemId) => onFilter({ orderItemId })} />
          ),
        },
        {
          accessor: 'orderCancelStatus',
          Header: '취소 처리 상태',
          width: 120,
          Cell: (row) => ORDER_CANCEL_STATUS_TEXT[row.value] || '_',
        },
        {
          accessor: 'cancelType',
          Header: '취소 사유',
          width: 120,
          Cell: (row) =>
            !isNull(row.value) ? (
              <Anchor
                color="primary"
                isUnderLine
                onClick={async () =>
                  await asyncSimpleModal({
                    title: '취소 사유',
                    message: row.original.cancelReason,
                  })
                }
                text={ORDER_CANCEL_TYPE_TEXT[row.value]}
              />
            ) : (
              '-'
            ),
        },
        {
          accessor: 'acceptManager',
          Header: '취소접수자',
          width: 100,
          Cell: (row) => setDash(ORDER_ACCEPT_MANAGER_TEXT[row.value]),
        },
        {
          accessor: 'cancelManager',
          Header: '취소처리자',
          width: 100,
          Cell: (row) => setDash(ORDER_PROCESS_MANAGER_TEXT[row.value]),
        },
      ],
    },
    {
      Header: '취소 거부',
      columns: [
        {
          accessor: 'rejectReason',
          Header: '거부 사유',
          width: 120,
          Cell: (row) =>
            !isNull(row.value) ? (
              <Anchor
                color="primary"
                isUnderLine
                onClick={async () =>
                  await asyncSimpleModal({
                    title: '취소 거부 사유',
                    message: row.original.rejectReason,
                  })
                }
                text="사유 보기"
              />
            ) : (
              '-'
            ),
        },
        {
          accessor: 'rejectDate',
          Header: '거부 일시',
          width: 150,
          Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
        },
      ],
    },
    {
      Header: '취소 정보',
      columns: [
        {
          accessor: 'orderDate',
          Header: '주문 일시',
          sortable: true,
          filterable: true,
          width: 320,
          Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
          Filter: () => (
            <DateRangePicker
              value={filterOption.orderDate}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(data) => onFilter({ orderDate: data })}
            />
          ),
        },
        {
          accessor: 'paymentDate',
          Header: '결제 일시',
          sortable: true,
          filterable: true,
          width: 320,
          Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
          Filter: () => (
            <DateRangePicker
              value={filterOption.paymentDate}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(data) => onFilter({ paymentDate: data })}
            />
          ),
        },
        {
          accessor: 'canceledDate',
          Header: '취소요청 일시',
          sortable: true,
          filterable: true,
          width: 320,
          Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
          Filter: () => (
            <DateRangePicker
              value={filterOption.canceledDate}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(data) => onFilter({ canceledDate: data })}
            />
          ),
        },
        {
          accessor: 'cancelCompleteDate',
          Header: '취소완료 일시',
          sortable: true,
          filterable: true,
          width: 320,
          Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
          Filter: () => (
            <DateRangePicker
              value={filterOption.cancelCompleteDate}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(data) => onFilter({ cancelCompleteDate: data })}
            />
          ),
        },
      ],
    },
    {
      Header: '구매 상품 정보',
      columns: [
        {
          accessor: 'brandName',
          Header: '브랜드명',
          resizable: true,
          filterable: true,
          width: setColumnWidth(list, 'brandName'),
          Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
          Filter: () => (
            <TableFilterInput option={filterOption.brandName} onFilter={(brandName) => onFilter({ brandName })} />
          ),
        },
        {
          accessor: 'storeId',
          Header: '브랜드 ID',
          filterable: true,
          width: 70,
          Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
          Filter: () => (
            <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />
          ),
        },
        {
          accessor: 'productId',
          Header: '상품번호',
          filterable: true,
          Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
          Filter: () => (
            <TableFilterInput option={filterOption.productId} onFilter={(productId) => onFilter({ productId })} />
          ),
        },
        {
          accessor: 'productName',
          Header: '상품명',
          className: 'align-left',
          resizable: true,
          filterable: true,
          width: setColumnWidth(list, 'productName'),
          Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
          Filter: () => (
            <TableFilterInput option={filterOption.productName} onFilter={(productName) => onFilter({ productName })} />
          ),
        },
        {
          accessor: 'mainCategory',
          Header: '1차 카테고리',
          width: setColumnWidth(list, 'mainCategory') + 40,
          filterable: true,
          Filter: () => (
            <Select
              list={addAllItemToSelectList(mainProductCategorySelectList)}
              onChange={(mainCategory) =>
                onFilter({
                  mainCategory,
                  subCategory: null,
                })
              }
              defaultValue={filterOption.mainCategory}
              value={filterOption.mainCategory}
              isTable={true}
              size="large"
            />
          ),
        },
        {
          accessor: 'productOptionName',
          Header: '옵션정보',
          resizable: true,
          width: setColumnWidth(list, 'productOptionName'),
          Cell: (row) => setDash(row.value),
        },
        {
          accessor: 'quantity',
          Header: '수량',
          Cell: (row) => setNumberWithComma(row.value),
        },
        {
          accessor: 'productOriginalPrice',
          Header: '상품 가격(정가)',
          width: 130,
          Cell: (row) => setNumberWithComma(row.value),
        },
        {
          accessor: 'productDiscountPrice',
          Header: '상품 할인액(차감된 금액)',
          width: 160,
          Cell: (row) => setNumberWithComma(row.value),
        },
        {
          accessor: 'productOptionPrice',
          Header: '옵션 가격',
          Cell: (row) => setNumberWithComma(row.value),
        },
        {
          accessor: 'usedCoupon',
          Header: '쿠폰',
          Cell: (row) => setNumberWithComma(row.value),
        },
        {
          accessor: 'usedPoint',
          Header: '포인트',
          Cell: (row) => setNumberWithComma(row.value),
        },
        {
          accessor: 'totalPrice',
          Header: '상품별 총 주문금액',
          width: 150,
          Cell: (row) => setNumberWithComma(row.value),
        },
        {
          accessor: 'deliveryExtraFee',
          Header: '추가 배송비',
          Cell: (row) => setNumberWithComma(row.value),
        },
        {
          accessor: 'orderMessage',
          Header: '주문 메시지',
          Cell: (row) => setOrderMessage(row.value),
        },
      ],
    },
    {
      Header: '구매자 정보',
      columns: [
        {
          accessor: 'buyerAccount',
          Header: '구매자 ID',
          filterable: true,
          width: setColumnWidth(list, 'buyerAccount'),
          Cell: (row) => <OpenUserDetail text={row.value} userId={row.original.userId} />,
          Filter: () => (
            <TableFilterInput
              option={filterOption.buyerAccount}
              onFilter={(buyerAccount) => onFilter({ buyerAccount })}
            />
          ),
        },
        {
          accessor: 'buyerName',
          Header: ' 구매자명',
          filterable: true,
          width: setColumnWidth(list, 'buyerName'),
          Filter: () => (
            <TableFilterInput option={filterOption.buyerName} onFilter={(buyerName) => onFilter({ buyerName })} />
          ),
        },
        {
          accessor: 'buyerPhone',
          Header: '구매자 연락처',
          filterable: true,
          width: 170,
          Cell: (row) => (
            <SendMessageService
              text={setPhoneFormat(row.value)}
              memberType={AMONDZ_MEMBER_TYPE.USER}
              targetId={row.original.userId}
            />
          ),
          Filter: () => (
            <TableFilterInput
              option={filterOption.buyerPhone}
              onFilter={(buyerPhone) =>
                onFilter({
                  buyerPhone: setClearDash(buyerPhone),
                })
              }
            />
          ),
        },
        {
          accessor: 'recipientName',
          Header: ' 수취인명',
          filterable: true,
          width: setColumnWidth(list, 'recipientName'),
          Filter: () => (
            <TableFilterInput
              option={filterOption.recipientName}
              onFilter={(recipientName) => onFilter({ recipientName })}
            />
          ),
        },
        {
          accessor: 'recipientPhone',
          Header: '수취인 연락처',
          filterable: true,
          width: 170,
          Cell: (row) => (
            <SendMessageService
              text={setPhoneFormat(row.value)}
              memberType={AMONDZ_MEMBER_TYPE.RECIPIENT}
              targetId={row.original.orderItemId}
            />
          ),
          Filter: () => (
            <TableFilterInput
              option={filterOption.recipientPhone}
              onFilter={(recipientPhone) =>
                onFilter({
                  recipientPhone: setClearDash(recipientPhone),
                })
              }
            />
          ),
        },
        {
          accessor: 'address',
          Header: '배송지',
          resizable: true,
          width: setColumnWidth(list, 'address'),
        },
        {
          accessor: 'postCode',
          Header: '우편번호',
        },
        {
          accessor: 'message',
          Header: '배송 메시지',
          className: 'align-left',
          resizable: true,
          width: 200,
        },
      ],
    },
    {
      Header: '결제',
      columns: [
        {
          accessor: 'payMethod',
          Header: '결제수단',
          filterable: true,
          width: 170,
          Cell: (row) => PAY_METHOD_TYPE_TEXT[row.value] || '_',
          Filter: () => (
            <Select
              list={PAYMENT_METHOD_TYPE_SELECT_LIST}
              onChange={(payMethod) => onFilter({ payMethod })}
              defaultValue={filterOption.payMethod}
              value={filterOption.payMethod}
              isTable={true}
              size="large"
            />
          ),
        },
      ],
    },
  ];
};

export default columns;
